<div class="prof">
    <section class="mainSect">
        <img [src]="profileJson['picture']" alt="">
        <div>
            <h2>{{profileJson["nickname"]}}</h2>
            <section>
                <div>
                    <h2>Posts</h2>
                    <h3>{{totalPosts}}</h3>
                </div>
                <div>
                    <h2>Messages</h2>
                    <h3>{{totalMessages}}</h3>
                </div>
            </section>
        </div>
    </section>

</div>
<div class=profarea>
    <section>
        <div class="profbuttons">
            <a (click)="categorySelect('post')" #post>Posts</a>
            <a (click)="categorySelect('message')" #message class="selectedH2"> Messages</a>
            <a (click)="categorySelect('PA')" #PA>+ Post</a>
            <a *ngIf="edit" (click)="categorySelect('EA')" #EA class="selectedH2">Edit Post</a> 
        </div>
        <!-- <div class="search" *ngIf="category === 'post'">
            <input type="text">
            <button>Submit</button>
            <section>
                <h4 (click)="">All</h4>
                <h4>Personal</h4>
            </section>
        </div>

        <div class="search" *ngIf="category === 'message'">
            <input type="text">
            <button>Submit</button>
            <section>
                <h4>All</h4>
                <h4>Personal</h4>
            </section>
        </div> -->
        <div class="arrowarea" *ngIf="add === false" >
            <button *ngIf="((nextPost === true && category === 'post' && totalPosts > 0) || (prevPost === true && category === 'post' && totalPosts > 0) || (nextMessage === true && category === 'message' && totalMessages > 0) || (prevMessage === true && category === 'message' && totalMessages > 0)) else notShown" class="arrows" #leftarrow (click)="pageTurnLeft(prevPost, nextPost, totalPostsPages, prevMessage, nextMessage, totalMessagesPages, category)">←</button>
            <ng-template #notShown>
                <button class="arrows" style="visibility:hidden;">←</button>
            </ng-template>
            <h2 *ngIf="category === 'post' && totalPosts > 0">Page {{currentPostPage}} of {{totalPostsPages}}</h2>
            <h2 *ngIf="category === 'message' && totalMessages > 0">Page {{currentMessagePage}} of {{totalMessagesPages}}</h2>
            <button *ngIf="((nextPost === true && category === 'post') || (prevPost === true && category === 'post') || (nextMessage === true && category === 'message') || (prevMessage === true && category === 'message')) else notShown" class="arrows" (click)="pageTurnRight(prevPost, nextPost, totalPostsPages, prevMessage, nextMessage, totalMessagesPages, category)" #rightarrow>→</button>
            <ng-template #notShown>
                <button class="arrows" style="visibility:hidden;">→</button>
            </ng-template>
        </div>
    </section>
    <section class="space">
        <div class="loading" *ngIf="(postSubmitted==='loading' && category==='post') || (messageSubmitted==='loading' && category==='message')">
            <img src="../../assets/img/ExcessMaterialLoading.png" alt="">
            <h1>LOADING...</h1>
        </div>

        <div *ngIf="category ==='message' && messageSubmitted !=='loading'">
            <app-message (reloadMessageData)="reloadMessageData($event)" [totalMessages]="totalMessages"  *ngFor="let message of userMessages" [single_message]="message"></app-message>
        </div>

        <div *ngIf="category==='post' && postSubmitted !=='loading'">
            <app-post (edittingPost)="editPost($event)" (reloadPostData)="reloadPostData($event, totalPosts)" *ngFor="let post of userPosts" [single_post]="post" [totalPosts]="totalPosts"></app-post>
        </div>
        <div *ngIf="category==='PA'">
            <h1>Add Post</h1>
            <app-editor [editVal]="edit" [addVal]="add" (reloadPostData)="reloadPostData($event, totalPosts)"></app-editor>
        </div>

        <div *ngIf="category==='EA'">
            <h1>Edit Post</h1>
            <app-editor [editVal]="edit" [edittedPost]="edittedPost" [addVal]="add" [currentPostPage]="currentPostPage" (reloadPostData)="reloadPostData($event, totalPosts)" [totalPosts]="userPosts.length"
            ></app-editor>
        </div>
    </section>
</div>